export default "__VITE_ASSET__CqUAvizn__"